'use strict'

Vue.component('awe-accordion', {
  props:{
    defaultOpen: {type: Boolean, default: false},
  },
  data() {
    return {
      isOpen: this.defaultOpen,
    };
  },
  methods: {
    toggleAccordion() {
      this.isOpen = !this.isOpen;
    }
  },
  template: `
    <div class="accordion">
      <div class="accordion-header" @click="toggleAccordion">
        <slot name="title"/>
        <svg  class="accordion-arrow" :class="{ 'arrow-rotate': isOpen }" viewBox="0 0 28 15" xmlns="http://www.w3.org/2000/svg">
          <path d="M21 1a2.1213 2.6517 45 013 3L14 14a2 2.1 0 01-3 0L1 4a2.6517 2.1213 45 013.0988-2.9012l8.5 8.5z"/>
        </svg>
      </div>
      <transition name="slide">
        <div v-show="isOpen" class="accordion-content">
          <slot name="content"/>
        </div>
      </transition>
    </div>
  `
})
